import React, { useState } from 'react';
import './VariableInput.css';

const VariableInput = ({ variables, onChange }) => {
  const [newVariable, setNewVariable] = useState({
    name: '',
    defaultValue: '',
    type: 'string',
    description: ''
  });

  const handleAddVariable = () => {
    if (!newVariable.name.trim()) return;

    const variable = {
      id: Date.now(),
      ...newVariable,
      name: newVariable.name.trim()
    };

    onChange([...variables, variable]);
    setNewVariable({
      name: '',
      defaultValue: '',
      type: 'string',
      description: ''
    });
  };

  const handleRemoveVariable = (id) => {
    onChange(variables.filter(v => v.id !== id));
  };

  const handleUpdateVariable = (id, field, value) => {
    onChange(variables.map(v =>
      v.id === id ? { ...v, [field]: value } : v
    ));
  };

  const validateVariableName = (name) => {
    if (!name) return '';
    if (!/^[a-zA-Z][a-zA-Z0-9_]*$/.test(name)) {
      return '변수명은 영문자로 시작하고 영문, 숫자, 언더스코어만 사용 가능합니다.';
    }
    if (variables.some(v => v.name === name)) {
      return '이미 존재하는 변수명입니다.';
    }
    return '';
  };

  const variableNameError = validateVariableName(newVariable.name);

  return (
    <div className="variable-input-container">
      <div>
        <h3 className="variable-title">변수 관리</h3>
        <p className="variable-description">
          URL 템플릿, 헤더, 바디에서 사용할 변수들을 정의하세요. Mustache 문법으로 사용됩니다.
        </p>
      </div>

      <div className="variable-help">
        <p className="variable-help-title">
          💡 사용 예시: {'{{변수명}}'} 형태로 템플릿에서 활용
        </p>
        <div className="variable-helper-buttons">
          <button type="button" className="variable-helper-btn">{'{{category}}'}</button>
          <button type="button" className="variable-helper-btn">{'{{page}}'}</button>
          <button type="button" className="variable-helper-btn">{'{{userId}}'}</button>
          <button type="button" className="variable-helper-btn">{'{{token}}'}</button>
        </div>
      </div>

      {/* 등록된 변수 목록 */}
      {variables.length > 0 ? (
        <div className="variables-list">
          <h4 className="preview-title">등록된 변수 ({variables.length}개)</h4>
          {variables.map((variable) => (
            <div key={variable.id} className="variable-item">
              <div className="variable-fields">
                <div className="variable-field">
                  <label className="variable-field-label">변수명</label>
                  <div className="preview-variable">{'{{' + variable.name + '}}'}</div>
                </div>
                <div className="variable-field">
                  <label className="variable-field-label">기본값</label>
                  <input
                    type="text"
                    value={variable.defaultValue}
                    onChange={(e) => handleUpdateVariable(variable.id, 'defaultValue', e.target.value)}
                    className="variable-field-input"
                    placeholder="기본값 입력"
                  />
                </div>
                <div className="variable-field">
                  <label className="variable-field-label">타입</label>
                  <select
                    value={variable.type}
                    onChange={(e) => handleUpdateVariable(variable.id, 'type', e.target.value)}
                    className="variable-field-select"
                  >
                    <option value="string">문자열</option>
                    <option value="number">숫자</option>
                    <option value="boolean">불린</option>
                    <option value="array">배열</option>
                  </select>
                </div>
              </div>
              <button
                onClick={() => handleRemoveVariable(variable.id)}
                className="variable-remove-btn"
                title="변수 삭제"
              >
                🗑️
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-variables">
          <div className="empty-variables-icon">📝</div>
          <div className="empty-variables-text">등록된 변수가 없습니다</div>
          <div className="empty-variables-description">아래에서 새 변수를 추가해보세요.</div>
        </div>
      )}

      {/* 새 변수 추가 폼 */}
      <div className="add-variable-section">
        <div className="add-variable-fields">
          <div>
            <label className="variable-field-label">변수명 *</label>
            <input
              type="text"
              value={newVariable.name}
              onChange={(e) => setNewVariable(prev => ({ ...prev, name: e.target.value }))}
              className="add-variable-input"
              placeholder="예: category, page, userId"
            />
            {variableNameError && (
              <div style={{ color: '#dc3545', fontSize: '0.8rem', marginTop: '4px' }}>
                {variableNameError}
              </div>
            )}
          </div>
          <div>
            <label className="variable-field-label">기본값</label>
            <input
              type="text"
              value={newVariable.defaultValue}
              onChange={(e) => setNewVariable(prev => ({ ...prev, defaultValue: e.target.value }))}
              className="add-variable-input"
              placeholder="기본값 입력"
            />
          </div>
          <div>
            <label className="variable-field-label">타입</label>
            <select
              value={newVariable.type}
              onChange={(e) => setNewVariable(prev => ({ ...prev, type: e.target.value }))}
              className="add-variable-select"
            >
              <option value="string">문자열</option>
              <option value="number">숫자</option>
              <option value="boolean">불린</option>
              <option value="array">배열</option>
            </select>
          </div>
          <button
            type="button"
            onClick={handleAddVariable}
            disabled={!newVariable.name.trim() || !!variableNameError}
            className="add-variable-btn"
          >
            ➕ 추가
          </button>
        </div>
      </div>

      {/* 변수 미리보기 */}
      {variables.length > 0 && (
        <div className="variables-preview">
          <div className="preview-title">사용 가능한 변수들</div>
          <div className="preview-list">
            {variables.map(variable => (
              <span key={variable.id} className="preview-variable">
                {'{{' + variable.name + '}}'}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default VariableInput;